<div *ngIf="visible" class="edit-template-form">
  <div class="template-editor-header">
    <h2>{{ editingTemplate ? 'Edit Template' : 'Create Template' }}</h2>
    <div class="template-editor-actions">
      <button pButton pRipple label="Cancel" class="p-button-outlined mr-2"
        (click)="cancelTemplateEditing()"></button>
      <button pButton pRipple label="{{ editingTemplate ? 'Update Template' : 'Save Template' }}"
        class="p-button-primary" (click)="saveTemplate()"></button>
    </div>
  </div>

  <div class="template-form-grid">
    <!-- Template Editor -->
    <div class="template-editor">
      <div class="form-field">
        <label for="templateName">Template Name</label>
        <input id="templateName" type="text" pInputText [(ngModel)]="currentTemplate.name" class="w-full"
          placeholder="Enter template name">
      </div>

      <div class="form-field">
        <label for="subjectLine">Subject Line</label>
        <input id="subjectLine" type="text" pInputText [(ngModel)]="currentTemplate.subject" class="w-full"
          placeholder="Enter subject line">
      </div>

      <div class="form-field">
        <label for="emailBody">Email Body</label>
        <p-editor #emailEditor [(ngModel)]="currentTemplate.body" [style]="{'height':'320px'}"
          placeholder="Write your email content here...">
          <ng-template pTemplate="header">
            <span class="ql-formats">
              <button type="button" class="ql-bold" aria-label="Bold"></button>
              <button type="button" class="ql-italic" aria-label="Italic"></button>
              <button type="button" class="ql-underline" aria-label="Underline"></button>
            </span>
            <span class="ql-formats">
              <button type="button" class="ql-list" value="ordered" aria-label="Ordered List"></button>
              <button type="button" class="ql-list" value="bullet" aria-label="Bullet List"></button>
            </span>
            <span class="ql-formats">
              <button type="button" class="ql-link" aria-label="Insert Link"></button>
            </span>
            <span class="ql-formats" style="margin-left: 15px;">
              <button type="button" pButton pRipple (click)="insertPersonalizationVariable('firstName')"
                label="First Name" class="p-button-sm p-button-purple-outlined mr-2"></button>
              <button type="button" pButton pRipple (click)="insertPersonalizationVariable('lastName')"
                label="Last Name" class="p-button-sm p-button-purple-outlined mr-2"></button>
              <button type="button" pButton pRipple (click)="insertPersonalizationVariable('company')" label="Company"
                class="p-button-sm p-button-outlined p-button-purple-outlined mr-2"></button>
              <button type="button" pButton pRipple (click)="insertPersonalizationVariable('title')" label="Title"
                class="p-button-sm p-button-outlined p-button-purple-outlined mr-2"></button>
              <button type="button" pButton pRipple (click)="insertPersonalizationVariable('accountSignature')" label="Account Signature"
                class="p-button-sm p-button-outlined p-button-purple-outlined mr-2"></button>
            </span>
          </ng-template>
        </p-editor>
      </div>

      <div class="personalization-info mt-4">
        <p-panel header="Using Personalization Variables" [toggleable]="true">
          <p ngNonBindable>Use double curly braces to insert variables, e.g. {{firstName}}, {{company}}</p>
          <p>Available variables:</p>
          <div class="variable-chips">
            <span class="variable-chip" (click)="insertPersonalizationVariable('firstName')">First Name</span>
            <span class="variable-chip" (click)="insertPersonalizationVariable('lastName')">Last Name</span>
            <span class="variable-chip" (click)="insertPersonalizationVariable('company')">Company</span>
            <span class="variable-chip" (click)="insertPersonalizationVariable('title')">Title</span>
            <span class="variable-chip" (click)="insertPersonalizationVariable('accountSignature')">Account Signature</span>
          </div>
        </p-panel>
      </div>
    </div>

    <!-- Preview Panel -->
    <div class="template-preview">
      <div class="preview-header">
        <h3>Email Preview</h3>
        <button pButton pRipple label="Refresh Preview" icon="pi pi-refresh" class="p-button-sm p-button-outlined"
          (click)="previewTemplate()"></button>
      </div>

      <div class="preview-container">
        <div class="preview-personalization">
          <h4>Personalization Variables</h4>
          <div class="preview-variable">
            <label>Company</label>
            <input type="text" pInputText [(ngModel)]="previewData.company" class="w-full">
          </div>
          <div class="preview-variable">
            <label>First Name</label>
            <input type="text" pInputText [(ngModel)]="previewData.firstName" class="w-full">
          </div>
          <div class="preview-variable">
            <label>Last Name</label>
            <input type="text" pInputText [(ngModel)]="previewData.lastName" class="w-full">
          </div>
          <div class="preview-variable">
            <label>Title</label>
            <input type="text" pInputText [(ngModel)]="previewData.title" class="w-full">
          </div>
        </div>

        <div class="email-preview-container">
          <div class="email-preview-header">
            <div><strong>From:</strong> Your Name</div>
            <div><strong>To:</strong> {{previewData.firstName}} {{previewData.lastName}}</div>
            <div><strong>Subject:</strong> {{currentTemplate.subject}}</div>
          </div>
          <div class="email-preview-body" [innerHTML]="previewBody"></div>
        </div>
      </div>
    </div>
  </div>
</div>